import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { createPanelSlice, type PanelSlice } from '~/components/v2/store/shared/createPanelSlice';
import { BOARD_SIDEBAR } from '~/constants/localStorageKeys';

export type BoardSidebarState = PanelSlice;

export const useBoardSidebarStore = create<BoardSidebarState>()(
  devtools(
    persist(
      (...args) => ({
        ...createPanelSlice({ open: false })(...args),
      }),
      {
        name: BOARD_SIDEBAR,
        partialize: (state) => ({
          open: state.open,
        }),
        version: 1,
      },
    ),
  ),
);
